export const facebookTextFieldStyles = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "16px",
        height: "52px",
        backgroundColor: "#FFFFFF",
        fontSize: "17px",
        "& fieldset": {
            borderColor: "#ccd0d5",
        },
        "&:hover fieldset": {
            borderColor: "#ccd0d5",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#089850",
            borderWidth: "1px",
        },
        "& legend": {
            display: "none",
        },
    },
    "& .MuiOutlinedInput-input": {
        paddingTop: "26px !important",
        paddingBottom: "10px !important",
        boxSizing: "border-box",
    },
    // ADD THIS NEW RULE: Ensures text safely clears the eye icon visibility button
    "& .MuiOutlinedInput-inputAdornedEnd": {
        paddingRight: "0px !important",
    },
    "& .MuiInputLabel-root": {
        fontSize: "16px",
        color: "#8d949e",
        transform: "translate(14px, 16px) scale(1)",
        pointerEvents: "none",
    },
    "& .MuiInputLabel-shrink": {
        transform: "translate(14px, 6px) scale(0.75) !important",
        color: "#1877F2",
    },
};

export const facebookDropdownStyles = {
    ...facebookTextFieldStyles,
    "& .MuiSelect-icon": {
        top: "calc(50% - 12px)",
        right: "12px",
    },
    "& .MuiSelect-select": {
        paddingTop: "26px !important",
        paddingBottom: "10px !important",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
    }
};

export const loginButton = {
    backgroundColor: "#05305A",
    mt: 2,
    borderRadius: "16px",
    height: "45px",
    fontSize: "15px",
}

export const forgetPasswordLink = {
    width: "100%",
    textAlign: "center",
    alignSelf: "center",
    color: "#000000",
    fontSize: "14px",
    fontWeight: "500",
    textDecoration: "none",
    padding: "12px 16px",
    borderRadius: "16px",
    transition: "all 0.2s ease-in-out",

    "&:hover": {
        backgroundColor: "#E4E6EB",
        borderRadius: "16px",
        color: "#000000"
    }
}

export const createNewAccountLink = {
    width: "100%",
    textAlign: "center",
    alignSelf: "center",
    color: "#000000",
    fontSize: "14px",
    fontWeight: "500",
    textDecoration: "none",
    padding: "12px 16px",
    borderRadius: "16px",
    border: "1px solid #05305A",
    transition: "all 0.2s ease-in-out",

    "&:hover": {
        backgroundColor: "#E4E6EB",
        border: "1px solid #089850",
        borderRadius: "16px",
        color: "#000000"
    }
}